import './ProviderDataStyle.css';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

export default function DHIGWM() {
  return (
    <>
      <div className="dialogSummary">
        The DHI global wave model dataset (GWM) is generated by DHI's 3rd generation MIKE 21
        Spectral Wave Model based on the high accuracy global ERA5 wind dataset from ECMWF. The ERA5
        wind dataset is an exceptionally good basis for global (and regional) wave modelling, and
        Wind Speeds &gt; 12 m/s have been corrected for a better representation of wave modelling.
        The model includes island parameterisation and data assimilation of satellite altimeter data,
        The results have been calibrated and validated against a number of offshore buoys and
        satellite data.
      </div>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              General
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell>
              Global, Waves, MIKE 21 Spectral Wave Model (SW), ERA5, DHI (DHI GWM 2024)
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Geographical Coverage</TableCell>
            <TableCell>Global</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Category</TableCell>
            <TableCell>Waves</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Source Name</TableCell>
            <TableCell>MIKE 21 Spectral Wave Model (SW)</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Publisher</TableCell>
            <TableCell>DHI</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Cost (ex. VAT)</TableCell>
            <TableCell>Requires MIKE Data Link Premium Subscription (TBC)</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Typical Applications</TableCell>
            <TableCell>Metocean studies, Hydrodynamic, Offshore and Marine projects</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Usage Limitations</TableCell>
            <TableCell>
              Waves during Tropical cyclones (hurricanes/typhoons) may not be well represented
              (resolved). Data extracted in minor enclosed areas and near-shore may be affected by
              the spatial resolution.
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Coverage
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Geographical Reference</TableCell>
            <TableCell>EPSG:4326 (WGS84)</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Geographical Range</TableCell>
            <TableCell>
              Longitude: 180°W – 180°E <br /> Latitude: 79°S – 81°N
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Geographical Resolution</TableCell>
            <TableCell>Mainly 15 - 50km (flexible mesh with varying cell size)</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Vertical Reference</TableCell>
            <TableCell>Sea surface</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Reference</TableCell>
            <TableCell>UTC</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Range</TableCell>
            <TableCell>1979-2023</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Resolution</TableCell>
            <TableCell>1 hour</TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Variables
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Name (Unit)</TableCell>
            <TableCell>
              Significant Wave Height (Hm0), [m]
              <br />
              Peak Wave Period (Tp), [s]
              <br />
              Mean Wave Period (T01), [s]
              <br />
              Zero-crossing Wave Period (T02), [s]
              <br />
              Peak Wave Direction (PWD), [Deg. N. (coming from)]
              <br />
              Mean Wave Direction (MWD), [Deg. N. (coming from)]
              <br />
              Directional Standard Deviation (DSD), [degree]
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Definitions</TableCell>
            <TableCell>Total sea state, wind-sea and swell (wave-age)</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
}
